<template>
  <!-- 报价详情 -->
  <div class="detail">
    <!-- title -->
    <headers :params="hraderP"></headers>
    <div class="detail-header">
      <p>项目信息</p>
      <p>{{activeInfo.status | statusList}}</p>
    </div>
    <div class="detai-list">
      <div class="detai-list-1">
        <p class="name">{{activeInfo.projectName}}</p>
        <p style="display: flex;" v-if="activeInfo.status==0">剩余时长: <span class="blue"><van-count-down :time="time" /></span></p>
        <p>项目业态:
          <span v-for="item in activeInfo.secondBuildingTypeList" :key="item.id"> {{ item.name }}</span>
        </p>
        <p class="list">施工系统: <span v-for="item in activeInfo.systemList">{{item.name}}</span></p>
        <div class="detai-list-2">
          <div class="item">
            <p>项目阶段:</p>
            <p>{{activeInfo.projectStage | stageFilter}}</p>
          </div>
          <div class="item">
            <p>产品交付:</p>
             <p>{{activeInfo.putType | typeFilters}}</p>
          </div>
          <div class="item">
            <p>产品时间:</p>
            <p v-if="activeInfo.expectTime!=='初稿最终'">{{activeInfo.expectTime}}</p>
          </div>
          <div class="item">
            <p>项目地址:</p>
           <p>{{ activeInfo.provinceName }} <span v-if="activeInfo.provinceName">-</span> {{ activeInfo.cityName }}</p>
          </div>
        </div>
      </div>
      <!-- <div class="h12"></div>
      <div class="detai-list-3">
        <p class="number">定制方案合同</p>
        <div class="loadImg">
          <img src="../../assets/images/icon-wenjian.png" >
          <p>河姆渡园区楼宇监控系统方案定制合同.PD</p>
        </div>
        <div class="detai-list-2" style="border: none;">
          <div class="item">
            <p>订单编号:</p>
            <p>14548445545521</p>
          </div>
          <div class="item" v-if="activeInfo.status==1">
            <p>总报价:</p>
            <p class="red">¥{{activeInfo.totalCost}}</p>
          </div>
        </div>
      </div> -->

      <div class="" v-if="activeInfo.status==1">
        <div class="h12"></div>
        <div class="detai-list-3">
         <div class="detai-list-2" style="border: none;padding-top: 0;">
           <div class="item">
              <p>总报价:</p>
              <p  class="red">¥{{activeInfo.totalCost}}</p>
           </div>
           <div class="item">
              <p>时长:</p>
              <p>{{activeInfo.deliverDay}}</p>
           </div>
          </div>
        </div>
        <div class="h12"></div>
        <div class="detai-list-3">
          <p class="number">备注</p>
          <p class="remark">{{activeInfo.remarks}}</p>
        </diV>
      </div>


      <div class="baojia" v-if="activeInfo.status==0">
        <button type="button" class="rejust"  @click="rejust">拒绝报价</button>
        <button type="button" class="submit" @click="showPopup">填写报价</button>
      </div>
    </div>
    <!-- 弹框 填写报价-->
    <van-popup v-model="show">
      <div class="dialog">
        <p class="name">填写报价</p>
        <div class="dialog-item" style="margin-top: 12px; color:#FF6900">
          <span>设计费限价:{{activeInfo.totalCostLimit}}元</span>
          <span style="margin-left: 18px">限定工期:{{activeInfo.deliverDayLimit}}天</span>
        </div>
        <div class="dialog-item" >
          <p class="item-label long-lable">按照限价执行:</p>
          <div class="offer-detail-radio">
                <input type="radio"  :value="1" v-model="param.priceLimitFlag"><span v-cloak>确认</span>
                <input type="radio"  :value="0" v-model="param.priceLimitFlag"><span v-cloak>拒绝</span>
          </div>
        </div>


        <div class="dialog-item"  v-if="param.priceLimitFlag == 0">
          <p class="item-label">总报价:</p>
          <input type="text" name="" placeholder="请填写你的报价" v-model="param.totalCost"/>
          <span>元</span>
        </div>
        <div class="dialog-item"  v-if="param.priceLimitFlag == 0">
          <p class="item-label">时长:</p>
          <input type="text" name="" placeholder="请填写你需要的天数" v-model="param.deliverDay"/>
          <span>工作日</span>
        </div>
        <div class="dialog-item" style="align-items: initial;">
          <p class="item-label">备注:</p>
          <van-field
            v-model="param.remarks"
            rows="3"
            autosize
            type="textarea"
            maxlength="100"
            placeholder="请输入留言"
            show-word-limit
          />
        </div>
        <p class="blue" style="display: flex">
            <span style="flex-shrink: 0;">
                报价说明：
            </span>
            <span>
                1.报价不能高于最高限价，工期不能高于限定工期。<br> 2.设计费结款，不再提供发票。
            </span>
        </p>
        <div class="button" v-if="activeInfo.status==0">
          <button type="button" class="cancle" @click="cancle">取消</button>
          <button type="button" class="comfirm" @click="comfirm">继续</button>
        </div>
      </div>
    </van-popup>

    <router-link to="/index.html"><img src="../../assets/images/hjinexenter.png" alt="" class="to-index"></router-link>
  </div>
</template>

<script>
  import headers from '@/components/headerslf'
  import { getDesignDetail,addDesignquoted,updateDesignquoted } from '@/api/designer/designer'
  import { quoteStateFilter,stateFilter,stageFilter,typeFilters,statusList } from '@/filters/status'
  import { Dialog } from 'vant'
  export default{
    components: {
      headers
    },
    data() {
      return {
        hraderP: {
          title: '订单详情',
          lefticon: true
        },
        time: 30 * 60 * 60 * 1000,
        show: false,
        id:'',
        activeInfo:[],
        message:'',
        param:{
          deliverDay:'',
          id:'',
          totalCost:'',
          remarks:'',
          priceLimitFlag: 0
        },
        from:{
          id:'',
          status:2
        }
      }
    },
    filters: {
      statusList,stageFilter,typeFilters
    },
    created() {
       this.id = this.$route.query.id
       this.param.id = this.$route.query.id
       this.from.id = parseInt(this.$route.query.id)
       console.log(this.id,'this.id');
       this.getDetail();
    },
    methods:{
      showPopup(){
         this.show = true;
      },
      cancle(){
         this.show = false;
      },
      // 拒绝报价
      rejust(){
        Dialog.confirm({
          title: '',
          message: '确认拒绝报价?'
        }).then(() => {
          updateDesignquoted(this.from).then(res => {
            console.log(res);
            if(res.data.code==200){
              this.$toast.success('拒绝报价成功')
              setTimeout(() => {
                this.$router.push('/designer/quotation.html')
              }, 1000)
            }
          })
        }).catch(() => {
          // 取消
        })
      },
      // 添加报价
      comfirm(){
        let obj = JSON.parse(JSON.stringify(this.param))
        if (obj.priceLimitFlag === 0) {
            if (!obj.totalCost) {
                this.$toast('请输入总报价')
                return
            }
            if (obj.totalCost <= 0) {
                this.$toast('请输入正确的报价', 2000);
                return
            }
            if (obj.totalCost > +this.activeInfo.totalCostLimit) {
                this.$toast('不能超过设计费限价', 2000);
                return
            }
            if (!obj.deliverDay) {
                this.$toast('请输入工时')
                return
            }

            if (obj.deliverDay <= 0) {
                this.$toast('请输入正确的工时', 2000);
                return
            }
            if (obj.deliverDay > +this.activeInfo.deliverDayLimit) {
                this.$toast('不能超过限定工期', 2000);
                return
            }
        } else {
            obj.deliverDay = +this.activeInfo.deliverDayLimit
            obj.totalCost = +this.activeInfo.totalCostLimit
        }
        addDesignquoted(obj).then(res => {
          console.log(res,'res');
          if(res.data.code==200){
             this.$toast.success('确认报价成功')
             setTimeout(() => {
               this.$router.push('/designer/quotation.html')
             }, 1000)
          }
        })
      },
      getDetail(){
        let param= {
          id:this.id
        }
        getDesignDetail(param).then(result => {
          console.log(result);
          this.activeInfo = result.data.data
        })
      }
    }
  }
</script>

<style lang="scss">
  .detail{
    .van-popup{
      border-radius: 8px;
    }
    .van-cell{
      background: #F7F8FA;
      margin-left: 5px;
      width: 80%;
    }
    .van-count-down{
      color:#2F7BFF ;
    }
  }
</style>
<style lang="scss" scoped>
  .detail{
    background: #F6F6F6;
    .detail-header{
      height: 64px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      color:#fff;
      background-image: url(../../assets/images/back.png);
    }
    .detai-list{
      margin-top: -5px;
      .h12{
        height: 12px;
      }
      .detai-list-1{
        padding: 16px 16px 0 16px;
        background: #FFFFFF;
        border-radius: 10px 10px 0px 0px;
        p{
          margin-bottom: 16px;
        }
        .name{
          font-size: 15px;
          font-weight: bold;
          color: #222222;
          overflow: hidden;
          text-overflow: ellipsis;
          display: box;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .blue{
          color: #2F7BFF;
        }
        .list{
          span{
            display: inline-block;
            padding: 3px 6px;
            background: #EDF4FE;
            border-radius: 2px;
            border: 1px solid #9DC1FF;
            color: #2F7BFF;
            margin-right: 10px;
            margin-bottom: 10px;
          }
        }
      }
    }
    .detai-list-2{
      border-top: 1px dashed #ccc;
      padding-top: 20px;
      p{
        margin-bottom: 14px;
      }
      .item{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .red{
        color: #FF0000;
      }
    }
    .detai-list-3{
      padding: 16px 16px 0 16px;
      background: #fff;
      .remark{
        padding-bottom: 10px;
      }
      .number{
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 20px;
      }
      .loadImg{
        display: flex;
        align-items: center;
        img{
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
        p{
          color: #2E7BFF;
          text-decoration: underline ;
        }
      }
    }
    .baojia{
      padding: 39px 16px 10px 16px;
      display: flex;
      justify-content: center;
      button{
        width: 167px;
        height: 44px;
        border-radius: 4px;
        font-weight: 600;
      }
      .rejust{
        background: #ECF2FF;
        border: 1px solid #2F7BFF;
        color: #2F7BFF;
        margin-right: 10px;
      }
      .submit{
        background: #2F7BFF;
        border: 1px solid #2F7BFF;
        color: #fff;
      }
    }
  }
  .dialog{
    width: 290px;
    height: auto;
    background: #FFFFFF;
    border-radius: 8px;
    padding:16px 20px;
    .name{
      font-size: 20px;
      text-align: center;
      font-weight: 600;
      color: #333333;
      padding-bottom: 12px;
      border-bottom: 1px solid #eee;
    }
    .blue{
      font-size: 12px;
      color: #2F7BFF;
    }
    .dialog-item{
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .item-label{
        width: 60px;
        text-align: right;
        font-size: 15px;
        color: #222;
      }
      .long-lable {
        width: 100px;
        white-space: nowrap;
      }
      .offer-detail-radio {
        display: flex;
        align-items: center;
      }
      .offer-detail-radio input{
        width: 20px;
        height: 20px;
        position: relative;
        z-index: 1;
        margin-right: 5px;
      }
      input{
        width: 160px;
        height: 28px;
        background: #F7F8FA;
        border-radius: 2px;
        border: none;
        margin-left: 5px;
        margin-right: 8px;
        padding-left: 10px;
      }
    }
    .button{
      display: flex;
      justify-content: space-between;
      padding-top: 16px;
      button{
        width: 114px;
        height: 35px;
        border-radius: 8px;
        border: none;
        color: #fff;
      }
      .cancle{
          background:rgba(47, 123, 255, 0.1);
          color: #2F7BFF;
      }
      .comfirm{
        background: #2F7BFF;
      }
    }

  }
  .to-index{
      width: 122px;
      position: fixed;
      right: 10px;
      bottom: 80px;
    }
</style>



// WEBPACK FOOTER //
// src/view/designer/quotationDetail.vue